import { Loading } from "@/app/components/LoadingFilters";
import React from "react";

const NUMBER_OF_ROWS = 15;

const RandomWidth = ({
  className,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => {
  const randomNumber = Math.floor(Math.random() * 4) + 1;
  switch (randomNumber) {
    case 1:
      return <Loading className={`${className} w-8`} {...rest} />;
    case 2:
      return <Loading className={`${className} w-10`} {...rest} />;
    case 3:
      return <Loading className={`${className} w-12`} {...rest} />;
    default:
      return <Loading className={`${className} w-16`} {...rest} />;
  }
};

export const LoadingTable = () => (
  <div style={{ width: "1000px" }} className="overflow-scroll">
    <div className="grid grid-cols-1 gap-1">
      <div className="flex gap-2 border-b">
        <div className="h-12 w-12 flex items-center justify-center">
          <Loading className="h-4 w-4" />
        </div>
        <div className="h-12 w-24 flex items-center justify-start">
          <RandomWidth className="h-6" />
        </div>
        <div className="h-12 w-24 flex items-center justify-start">
          <RandomWidth className="h-6" />
        </div>
        <div className="h-12 w-24 flex items-center justify-start">
          <RandomWidth className="h-6" />
        </div>
        <div className="h-12 w-24 flex items-center justify-start">
          <RandomWidth className="h-6" />
        </div>
        <div className="h-12 w-24 flex items-center justify-start">
          <RandomWidth className="h-6" />
        </div>
        <div className="h-12 w-24 flex items-center justify-start">
          <RandomWidth className="h-6" />
        </div>
        <div className="h-12 w-24 flex items-center justify-start">
          <RandomWidth className="h-6" />
        </div>
        <div className="h-12 w-24 flex items-center justify-start">
          <RandomWidth className="h-6" />
        </div>
        <div className="h-12 w-24 flex items-center justify-start">
          <RandomWidth className="h-6" />
        </div>
        <div className="h-12 w-24 flex items-center justify-start">
          <RandomWidth className="h-6" />
        </div>
      </div>
      {Array.from(Array(NUMBER_OF_ROWS).keys()).map((i) => (
        <div className="flex gap-2" key={`${i}`}>
          <div className="h-8 w-12 flex items-center justify-center">
            <Loading className="h-4 w-4" />
          </div>
          <div className="h-8 w-24 flex items-center justify-start">
            <RandomWidth className="h-6" />
          </div>
          <div className="h-8 w-24 flex items-center justify-start">
            <RandomWidth className="h-6" />
          </div>
          <div className="h-8 w-24 flex items-center justify-start">
            <RandomWidth className="h-6" />
          </div>
          <div className="h-8 w-24 flex items-center justify-start">
            <RandomWidth className="h-6" />
          </div>
          <div className="h-8 w-24 flex items-center justify-start">
            <RandomWidth className="h-6" />
          </div>
          <div className="h-8 w-24 flex items-center justify-start">
            <RandomWidth className="h-6" />
          </div>
          <div className="h-8 w-24 flex items-center justify-start">
            <RandomWidth className="h-6" />
          </div>
          <div className="h-8 w-24 flex items-center justify-start">
            <RandomWidth className="h-6" />
          </div>
          <div className="h-8 w-24 flex items-center justify-start">
            <RandomWidth className="h-6" />
          </div>
          <div className="h-8 w-24 flex items-center justify-start">
            <RandomWidth className="h-6" />
          </div>
        </div>
      ))}
    </div>
  </div>
);
